<button (click)="openTaskDialog()" *ngIf="displayAddButton" color="primary" mat-raised-button>
	<span>NEW TASK</span>
</button>

<div
	(click)="openTaskDialog()"
	*ngIf="displayInputText"
	class="font-size-14 padding-0-5 cursor-pointer input-box"
	fxFlex
>
	Start typing to add a task
</div>

<span (click)="openTaskDialog()" *ngIf="displayAddLink" class="link">
	<span>New Task</span>
</span>
